import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

export const makeDataTestId = (dataTestId = 'eligibility-widget') => {
  return {
    wrapper: `${dataTestId}.token.status.wrapper`,
    header: `${dataTestId}.token.status.header`,
    body: `${dataTestId}.token.status.body`,
  };
};

interface EligibilityWidgetTokenStatusProps {
  children?: React.ReactNode;
  dataTestId?: string;
  header: string;
  body: string;
}

export const EligibilityWidgetTokenStatus: React.FC<EligibilityWidgetTokenStatusProps> = ({
  children,
  dataTestId,
  header,
  body,
}) => {
  const allDataTestId = makeDataTestId(dataTestId);

  return (
    <Grid container wrap="nowrap" direction="column" data-testid={allDataTestId.wrapper}>
      <Grid marginBottom={1.5} data-testid={allDataTestId.header}>
        <Typography variant="subtitle3-bold">{header}</Typography>
      </Grid>
      <Grid marginBottom={3} data-testid={allDataTestId.body}>
        <Typography variant="body1">{body}</Typography>
      </Grid>
      <Grid container direction="column" wrap="nowrap">
        <Grid>{children}</Grid>
      </Grid>
    </Grid>
  );
};

export default EligibilityWidgetTokenStatus;
